import React from 'react';
import { FadeIn } from './FadeIn';
import { Flower2, Moon, Leaf } from 'lucide-react';
export function MechanismSection() {
  const pillars = [{
    icon: <Flower2 className="w-8 h-8 text-copper" data-id="element-94" />,
    title: 'Movimiento Somático',
    desc: '(suave)'
  }, {
    icon: <Moon className="w-8 h-8 text-copper" data-id="element-95" />,
    title: 'Higiene del Sueño',
    desc: 'Descanso profundo'
  }, {
    icon: <Leaf className="w-8 h-8 text-copper" data-id="element-96" />,
    title: 'Nutrición Botánica',
    desc: 'Dirigida'
  }];
  return <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-97">
      <FadeIn data-id="element-98">
        <div className="text-center mb-12" data-id="element-99">
          <h3 className="text-rose-gold font-sans font-bold tracking-wider uppercase text-sm mb-2" data-id="element-100">
            Tu Nueva Metodología
          </h3>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-warm-dark mb-4" data-id="element-101">
            El Tridente de Bio-Armonía
          </h2>
          <div className="w-24 h-1 bg-copper mx-auto rounded-full mb-8" data-id="element-102"></div>
          <p className="text-lg text-warm-dark/80 font-sans max-w-2xl mx-auto" data-id="element-103">
            Es una metodología que combina tres pilares fundamentales para
            restaurar tu equilibrio natural:
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-104">
        {pillars.map((pillar, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-105">
            <div className="bg-cream p-8 rounded-2xl text-center border border-copper/20 h-full flex flex-col items-center justify-center" data-id="element-106">
              <div className="mb-4 p-4 bg-white rounded-full shadow-sm" data-id="element-107">
                {pillar.icon}
              </div>
              <h4 className="font-serif font-bold text-xl text-warm-dark mb-1" data-id="element-108">
                {pillar.title}
              </h4>
              <p className="text-warm-dark/60 font-sans text-sm" data-id="element-109">
                {pillar.desc}
              </p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.3} data-id="element-110">
        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-blush relative overflow-hidden" data-id="element-111">
          <div className="absolute top-0 right-0 w-32 h-32 bg-rose-gold/5 rounded-bl-full -z-0" data-id="element-112"></div>
          <p className="text-lg text-warm-dark/80 font-sans leading-relaxed relative z-10 text-center" data-id="element-113">
            A través del uso estratégico de{' '}
            <strong className="text-rose-gold font-serif text-xl" data-id="element-114">
              Women's Choice Plus
            </strong>{' '}
            y{' '}
            <strong className="text-rose-gold font-serif text-xl" data-id="element-115">
              Tang Kuei Plus
            </strong>
            , le entregamos a tu cuerpo las 'llaves' botánicas que encajan
            perfectamente en tus receptores hormonales, permitiendo que tu
            termostato interno se calibre y tu sistema nervioso se relaje de
            forma natural.
          </p>
        </div>
      </FadeIn>
    </section>;
}